export default {
    add: 'Προσθήκη νέου',
    empty: {
        title: 'Δεν έχεις πρότυπα εκτύπωσης ακόμα',
        subtitle: 'Πρόσθεσε ένα πρότυπο για να διαμορφώσεις τις εκτυπώσεις σου.'
    },
    title: 'Πρότυπα εκτύπωσης',
    subtitle: 'Δες και επεξεργάσου τα πρότυπα εκτύπωσής σου',
    limit: 'Μπορείς να έχεις έως 10 πρότυπα εκτύπωσης',
    default: 'Προεπιλεγμένο πρότυπο',
    system: 'Πρότυπο συστήματος',
    name: 'Όνομα προτύπου',
    defaultLabel: 'Προεπιλογή',
    markAsDefault: 'Ορισμός ως προεπιλεγμένο',
    modalTitle: 'Θέλετε σίγουρα να το ορίσετε ως προεπιλεγμένο;',
    modalBody: 'Το πρότυπο αυτό θα είναι αρχικά επιλεγμένο στις εκτυπώσεις σας.',
    copyTemplate: 'Αντιγραφή',
    copyName: 'Αντίγραφο του {name}',
    copyConfirmTitle: 'Αντιγραφή προτύπου;',
    copyConfirmBody: 'Θα δημιουργηθεί νέο πρότυπο με τις ίδιες ρυθμίσεις. Μπορείτε να το μετονομάσετε μετά.',
    edit: {
        title: 'Επεξεργασία προτύπου',
        subtitle: 'Επεξεργάσου το πρότυπο της εκτύπωσής σου',
        headerColor: 'Χρώμα κεφαλίδας',
        daysColor: 'Χρώμα ημέρων',
        tableStripes: 'Ρίγες πίνακα',
        tableBorders: 'Περιγράμματα πίνακα',
        background: 'Φόντο',
        text: 'Κείμενο',
        info: 'Πληροφορίες',
        meals: 'Γεύματα',
        days: 'Ημέρες (ή επιλογές)',
        foods: 'Τρόφιμα',
        categoryColors: 'Χρωματισμός τροφίμων με βάση την κατηγορία τους',
        stripes: {
            none: 'Χωρίς ρίγες',
            columns: 'Στήλες',
            rows: 'Γραμμές',
            mix: 'Σκακιέρα'
        },
        daySize: 'Μέγεθος ημερών',
        foodSize: 'Μέγεθος τροφίμων',
        letterSpacing: 'Αποστάση γραμμάτων',
        mealSize: 'Μέγεθος γευμάτων',
        fontFamily: 'Γραμματοσειρά',
        orientation: 'Προσανατολισμός εκτύπωσης',
        landscape: 'Οριζόντια (landscape)',
        portrait: 'Κατακόρυφα (portrait)',
        settings: {
            title: 'Γενικές ρυθμίσεις',
            template: 'Πρότυπο εκτύπωσης',
            showName: 'Εμφάνιση του ονόματός σας',
            showDate: 'Εμφάνιση ημερομηνίας',
            showNotes: 'Εμφάνιση σημειώσεων (σε νέα σελίδα)',
            showLogo: 'Εμφάνιση Λογοτύπου',
            reverseHeaders: 'Αντιστροφή ημερών / γευμάτων',
            showPlanName: 'Εμφάνιση ονόματος πλάνου',
            dietPlans: {
                title: 'Διατροφικό πλάνο',
                onePerPage: 'Εμφάνιση μιας ημέρας ανά σελίδα',
                showQuantity: 'Εμφάνιση ποσοτήτων τροφίμων',
                showAnalysis: 'Εμφάνιση της ανάλυσης του πλάνου',
                showExercises: 'Εμφάνιση της εβδομαδιαίας άσκησης',
                showRecipes: 'Συνταγές',
                includeRecipes: 'Συμπερίληψη συνταγών στην εκτύπωση',
                selectRecipes: 'Επιλέξτε συνταγές προς συμπερίληψη',
                selectAll: 'Επιλογή όλων',
                deselectAll: 'Αποεπιλογή όλων',
            },
            shoppingList: {
                title: 'Λίστα για τα ψώνια',
                show: 'Εκτύπωση λίστας τροφίμων για ψώνια;',
                showRecipes: 'Εκτύπωση σύνθετων τροφίμων;',
                showNotForgetList: 'Εκτύπωση λίστας "μην ξεχάσω...";',
                showFoodQuantities: 'Προβολή ποσότητας τροφίμων;',
                mergeFoods: 'Συγχώνευση τροφίμων (αγνόηση επεξεργασμένων ονομάτων);'
            },
        },
        translation: {
            titles: 'Τίτλοι',
            name: 'Όνομα πλάνου',
            date: 'Ημερομηνία',
            dietitian: 'Διατροφολόγος',
            days: 'Ονόματα ημερών',
            meals: 'Ονόματα γευμάτων',
            others: 'Άλλα κείμενα',
            shoppingList: 'Λίστα για ψώνια',
            dontForget: 'Μην ξεχάσετε επίσης τα υλικά των συνταγών...',
            doNotForget: 'Μην ξεχάσω...',
            energy: 'Ενέργεια',
            carbs: 'Υδατάνθρακες',
            proteins: 'Πρωτεϊνες',
            fats: 'Λίπη',
            fresh: 'Φρέσκιες',
            amylouxes: 'Αμυλούχες',
            animal: 'Ζωϊκές',
            complex: 'Σύνθετα',
            stats: 'Στατιστικά Τροφίμων'
        },
        header: {
            title: 'Κεφαλίδα',
            logoPosition: 'Θέση λογοτύπου',
            left: 'Αριστερά',
            right: 'Δεξιά',
            logoWidth: 'Πλάτος λογοτύπου',
            logoHeight: 'Ύψος λογοτύπου',
            logo: 'Λογότυπο',
            cropLogo: 'Περικοπή λογοτύπου',
            applyCrop: 'Εφαρμογή περικοπής',
            usingCustomLogo: 'Χρήση προσαρμοσμένου λογοτύπου',
            usingDefaultLogo: 'Χρήση προεπιλεγμένου λογοτύπου',
            uploadLogo: 'Ανέβασμα λογοτύπου',
            uploadCustom: 'Ανέβασμα προσαρμοσμένου',
            replaceLogo: 'Αντικατάσταση',
            borderRadius: 'Στρογγυλεμένες γωνίες',
            fontSize: 'Μέγεθος γραμματοσειράς',
            textWhenLogoLeft: 'Όταν το λογότυπο είναι αριστερά, κείμενο',
            textNextToLogo: 'Δίπλα στο λογότυπο',
            textRightAligned: 'Στοίχιση δεξιά',
        },
        tabs:{
            header: 'Κεφαλίδα',
            colors: 'Χρώματα',
            table: 'Πίνακας',
            text: 'Μεγέθη κειμένου',
            settings: 'Ρυθμίσεις',
            translation: 'Μετάφραση'
        }
    }



}